'use client';

import React, { useState } from 'react';

// ═══ P3-10: Notification Center ═══
interface Notification {
  id: string; type: 'post' | 'comment' | 'task' | 'mention' | 'system';
  title: string; body: string; projectName?: string;
  read: boolean; createdAt: string;
}

const typeIcons: Record<string, string> = {
  post: '📝', comment: '💬', task: '📋', mention: '@', system: '🔔',
};

export default function NotificationCenter({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const [notifications] = useState<Notification[]>([
    { id: '1', type: 'post', title: '새 게시물', body: '박현우님이 "대곡고_업무연락"을 작성했습니다.', projectName: 'ID_2531_대곡고', read: false, createdAt: '2026-03-12T09:00:00Z' },
    { id: '2', type: 'task', title: '업무 상태 변경', body: '"인테리어 실시설계 도서" → 완료', projectName: '에코1초', read: false, createdAt: '2026-03-11T17:30:00Z' },
    { id: '3', type: 'comment', title: '새 댓글', body: '기호을님이 댓글을 남겼습니다: "확인했습니다."', projectName: 'ID_2531_대곡고', read: true, createdAt: '2026-03-11T12:00:00Z' },
    { id: '4', type: 'mention', title: '멘션', body: '배경철님이 회의에서 회원님을 언급했습니다.', projectName: '주간업무보고', read: true, createdAt: '2026-03-10T10:00:00Z' },
  ]);

  const unreadCount = notifications.filter(n => !n.read).length;

  if (!isOpen) return null;

  return (
    <div className="fixed right-0 top-0 h-full w-80 z-50 flex flex-col shadow-2xl"
      style={{ background: 'var(--bg-secondary)', borderLeft: '1px solid var(--border-color)' }}>
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3" style={{ borderBottom: '1px solid var(--border-color)' }}>
        <h2 className="font-semibold text-sm flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
          🔔 알림
          {unreadCount > 0 && (
            <span className="px-1.5 py-0.5 rounded-full text-[10px] font-bold text-white" style={{ background: '#ef4444' }}>
              {unreadCount}
            </span>
          )}
        </h2>
        <button onClick={onClose} className="text-lg hover:text-red-400 transition-colors" style={{ color: 'var(--text-muted)' }}>✕</button>
      </div>

      {/* Notification list */}
      <div className="flex-1 overflow-auto">
        {notifications.map(n => (
          <div key={n.id} className={`px-4 py-3 cursor-pointer transition-colors ${!n.read ? 'bg-blue-500/5' : ''}`}
            style={{ borderBottom: '1px solid var(--border-color)' }}
            onMouseEnter={e => (e.currentTarget.style.background = 'var(--bg-card-hover)')}
            onMouseLeave={e => (e.currentTarget.style.background = !n.read ? 'rgba(59,130,246,0.05)' : 'transparent')}>
            <div className="flex gap-3">
              <span className="text-lg flex-shrink-0">{typeIcons[n.type]}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="text-xs font-semibold" style={{ color: 'var(--text-primary)' }}>{n.title}</p>
                  {!n.read && <div className="w-1.5 h-1.5 rounded-full bg-blue-500 flex-shrink-0" />}
                </div>
                <p className="text-xs mt-0.5 line-clamp-2" style={{ color: 'var(--text-secondary)' }}>{n.body}</p>
                <div className="flex items-center gap-2 mt-1">
                  {n.projectName && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded" style={{ background: 'var(--bg-badge)', color: 'var(--accent-blue)' }}>{n.projectName}</span>
                  )}
                  <span className="text-[10px]" style={{ color: 'var(--text-dim)' }}>
                    {new Date(n.createdAt).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
